import energyGroup from "./assets/energy-group.png"
import fibertime from "./assets/fibertime.png"
import herotel from "./assets/herotel.png"
import liquid from "./assets/liquid.png"
import vulatel from "./assets/vulatel.png"

export type ClientLogo = { name: string; src: string }

/**
 * The clients shown under "Trusted by" and below the reviews. Kept here, not in the CMS (Website → home page →
 * heroLogos / partnerLogos, no longer read): they rarely change, and from the code they are in the prerendered HTML.
 */
export const CLIENT_LOGOS: ClientLogo[] = [
  { name: "Energy Group", src: energyGroup },
  { name: "Vulatel", src: vulatel },
  { name: "Liquid Intelligent Technologies", src: liquid },
  { name: "Fibertime", src: fibertime },
  { name: "Herotel", src: herotel },
]

/**
 * The logos twice over, for the endless logo carousels: react-slick does not scroll when it has no more slides than
 * it shows at once (up to 8).
 */
export const CLIENT_LOGO_SLIDES: ClientLogo[] = [...CLIENT_LOGOS, ...CLIENT_LOGOS]
